export const CONTACT_STATUSES = [
  { value: "novo", label: "Novo" },
  { value: "respondido", label: "Respondido" },
  { value: "fechado", label: "Fechado" },
  { value: "descartado", label: "Descartado" },
];
